module.exports = __webpack_public_path__ + "img/b-2.c86e32e1.png";